import React from 'react';
import './MyMessage.css';

const MyMessage = () => {
  const sectionStyle = {
    '--mm-sun-img': `url("${process.env.PUBLIC_URL}/images/vtd-sun-logo.svg")`,
  };
  return (
  <section className="mm" id="my-message" style={sectionStyle} aria-label="A personal message from Tilak">
    <div className="mm__inner">
      <div className="mm__sun" aria-hidden="true" />

      <p className="mm__eyebrow">A Word From Tilak</p>
      <h2 className="mm__title">My Purpose. My Promise.</h2>
      <div className="mm__divider" />

      <blockquote className="mm__quote">
        <p>
          Astrology to me is not a business — it is a sacred trust passed down through three
          generations of my family. When you bring me your chart, you are placing your future
          in the hands of someone who has prayed to read it correctly.
        </p>
        <p>
          I will not flatter you. I will not predict only what you want to hear. I will tell you
          what your planets actually say — the bright periods, the difficult ones, and the
          remedies that can change what is changeable.
        </p>
        <p className="mm__hope">
          My hope is simple: that every person who finds VTD Astrology leaves with clarity,
          courage, and a real path forward. That is the only success I care about.
        </p>
      </blockquote>

      <div className="mm__sign">
        <span className="mm__sign-name">— Vavilaala Tilak Datta Sharma</span>
        <span className="mm__sign-role">Founder · VTD Astrology · Addanki, Andhra Pradesh</span>
      </div>

      <div className="mm__cta-row">
        <a href="/chat" className="mm__cta mm__cta--gold">Start a Reading →</a>
        <a href="/about" className="mm__cta mm__cta--ghost">My Story</a>
      </div>
    </div>
  </section>
  );
};

export default MyMessage;
